(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Campagna_logDeleteController',Campagna_logDeleteController);

    Campagna_logDeleteController.$inject = ['$uibModalInstance', 'entity', 'Campagna_log'];

    function Campagna_logDeleteController($uibModalInstance, entity, Campagna_log) {
        var vm = this;

        vm.campagna_log = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Campagna_log.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
